import type { UseMutationOptions, DefaultOptions } from '@tanstack/react-query';

export const queryConfig = {
  queries: {
    // throwOnError: true,
    refetchOnWindowFocus: false,
    retry: false,
    staleTime: 1000 * 60
  }
} satisfies DefaultOptions;

export type ApiFnReturnType<
  FnType extends (...args: never[]) => Promise<never>
> = Awaited<ReturnType<FnType>>;

export type QueryConfig<T extends (...args: never[]) => never> = Omit<
  ReturnType<T>,
  'queryKey' | 'queryFn'
>;

export type MutationConfig<
  MutationFnType extends (...args: never[]) => Promise<never>
> = UseMutationOptions<
  ApiFnReturnType<MutationFnType>,
  Error,
  Parameters<MutationFnType>[0]
>;
